import React from 'react';
import DiversityCenterTemplate from '@templates/DiversityCenter';

export default function DiversityCenter() {
  return (
    <DiversityCenterTemplate>
      <p>Content will go here</p>
    </DiversityCenterTemplate>
  );
}
